import {combineReducers} from 'redux';
import addoreditsku from './addoreditsku/reducer';
import listskus from './listskus/reducer';
import viewsku from './viewsku/reducer';
import addoreditlook from './addoreditlook/reducer';
import listlooks from './listlooks/reducer';
import viewlook from './viewlook/reducer';

export default combineReducers({
  addoreditsku,
  listskus,
  viewsku,
  addoreditlook,
  listlooks,
  viewlook,
});
